<div
  role="status"
  [class]="
    'inline-block animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] ' +
    color +
    ' ' +
    class
  "
  [ngStyle]="{ 'width.px': size, 'height.px': size }"
>
  <span class="sr-only" *ngIf="showLoadingText">Loading...</span>
</div>
